import { closeToast, showFailToast, showLoadingToast } from 'vant';
import { AppException } from './exception';
import { Ref, ref } from 'vue';

export type Handler = <T>(
    handle: () => Promise<T>,
) => Promise<T | null>;

type UseLoading = (isShowGlobalLoading?: boolean, loadingText?: string) => [Ref<boolean>, Handler];

export const useLoading: UseLoading = (isShowGlobalLoading = false, loadingText = '正在加载中') => {
    const loading = ref(false);
    const handler: Handler = async (handle) => {
        try {
            if (loading.value) return null;
            if (isShowGlobalLoading) {
                showLoadingToast(loadingText);
            }
            loading.value = true;
            const res = await handle();
            loading.value = false;
            return res;
        } catch (e) {
            loading.value = false;
            closeToast();
            if (e instanceof AppException) {
                showFailToast(e.message);
                throw e;
            }
            throw e;
        }
    };

    return [loading, handler];
};
